import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';

export default function AdminPanel() {
  const [tab, setTab] = useState('dashboard');
  const [stats, setStats] = useState(null);
  const [contatti, setContatti] = useState([]);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterStato, setFilterStato] = useState('');
  const [search, setSearch] = useState('');
  const [selectedContact, setSelectedContact] = useState(null);
  const [storico, setStorico] = useState([]);
  const [noteEdit, setNoteEdit] = useState('');

  const token = localStorage.getItem('vi_token');
  const api = axios.create({ baseURL: '/api', headers: { Authorization: `Bearer ${token}` } });

  useEffect(() => { loadData(); }, []);

  const loadData = async () => {
    try {
      const [statsRes, contattiRes, usersRes] = await Promise.all([
        api.get('/admin/stats'),
        api.get('/admin/contatti'),
        api.get('/admin/users')
      ]);
      setStats(statsRes.data);
      setContatti(contattiRes.data.contatti);
      setUsers(usersRes.data.users);
    } catch (err) { console.error(err); }
    setLoading(false);
  };

  const updateContatto = async (id, stato) => {
    try {
      await api.put(`/admin/contatti/${id}`, { stato });
      toast.success('Stato aggiornato');
      loadData();
    } catch { toast.error('Errore'); }
  };

  const saveNote = async (id) => {
    try {
      await api.put(`/admin/contatti/${id}`, { note: noteEdit });
      toast.success('Note salvate');
      loadData();
    } catch { toast.error('Errore'); }
  };

  const loadStorico = async (id) => {
    try {
      const res = await api.get(`/admin/contatti/${id}/storico`);
      setStorico(res.data.storico);
    } catch {}
  };

  const exportCSV = () => {
    window.open('/api/admin/contatti/export/csv', '_blank');
  };

  if (loading) return <div style={{ display: 'flex', justifyContent: 'center', padding: 60 }}><div className="spinner"></div></div>;

  const filteredContatti = contatti.filter(c => {
    if (filterStato && c.stato !== filterStato) return false;
    if (search) {
      const s = search.toLowerCase();
      return (c.nome?.toLowerCase().includes(s) || c.email?.toLowerCase().includes(s) || c.azienda?.toLowerCase().includes(s));
    }
    return true;
  });

  return (
    <div className="admin-layout">
      <div className="admin-sidebar">
        <h3 style={{ marginBottom: 16, fontSize: 16 }}>Admin Panel</h3>
        <button onClick={() => setTab('dashboard')} className={tab === 'dashboard' ? 'active' : ''} style={{ display: 'block', width: '100%', textAlign: 'left', padding: '10px 16px', color: tab === 'dashboard' ? 'white' : '#9ca3af', background: tab === 'dashboard' ? 'rgba(255,255,255,0.1)' : 'transparent', border: 'none', borderRadius: 8, cursor: 'pointer', marginBottom: 4, fontSize: 14 }}>Dashboard</button>
        <button onClick={() => setTab('contatti')} className={tab === 'contatti' ? 'active' : ''} style={{ display: 'block', width: '100%', textAlign: 'left', padding: '10px 16px', color: tab === 'contatti' ? 'white' : '#9ca3af', background: tab === 'contatti' ? 'rgba(255,255,255,0.1)' : 'transparent', border: 'none', borderRadius: 8, cursor: 'pointer', marginBottom: 4, fontSize: 14 }}>CRM Contatti</button>
        <button onClick={() => setTab('users')} className={tab === 'users' ? 'active' : ''} style={{ display: 'block', width: '100%', textAlign: 'left', padding: '10px 16px', color: tab === 'users' ? 'white' : '#9ca3af', background: tab === 'users' ? 'rgba(255,255,255,0.1)' : 'transparent', border: 'none', borderRadius: 8, cursor: 'pointer', marginBottom: 4, fontSize: 14 }}>Utenti</button>
        <Link to="/admin/analytics" style={{ display: 'block', padding: '10px 16px', color: '#9ca3af', borderRadius: 8, marginBottom: 4, fontSize: 14 }}>Analytics</Link>
      </div>

      <div className="admin-content">
        {/* Dashboard Tab */}
        {tab === 'dashboard' && stats && (
          <div>
            <h2 style={{ marginBottom: 20 }}>Dashboard Admin</h2>
            <div className="dashboard-grid">
              <div className="stat-card"><div className="stat-number">{stats.stats.totalUsers}</div><div className="stat-label">Utenti Registrati</div></div>
              <div className="stat-card"><div className="stat-number">{stats.stats.totalContatti}</div><div className="stat-label">Contatti Totali</div></div>
              <div className="stat-card"><div className="stat-number" style={{ color: '#f59e0b' }}>{stats.stats.contattiNuovi}</div><div className="stat-label">Contatti Nuovi</div></div>
              <div className="stat-card"><div className="stat-number">{stats.stats.reportGenerati}</div><div className="stat-label">Report Generati</div></div>
              <div className="stat-card"><div className="stat-number" style={{ color: '#16a34a' }}>{stats.stats.reportSbloccati}</div><div className="stat-label">Report Sbloccati</div></div>
              <div className="stat-card"><div className="stat-number">{stats.stats.visureCaricate}</div><div className="stat-label">Visure Caricate</div></div>
            </div>

            <h3 style={{ marginTop: 24, marginBottom: 12 }}>Ultimi Utenti Registrati</h3>
            <div className="table-container">
              <table>
                <thead><tr><th>Email</th><th>Nome</th><th>Azienda</th><th>Data</th></tr></thead>
                <tbody>
                  {stats.recentUsers.map(u => (
                    <tr key={u.id}><td>{u.email}</td><td>{u.nome} {u.cognome}</td><td>{u.azienda}</td><td>{new Date(u.created_at).toLocaleDateString('it-IT')}</td></tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* CRM Contatti Tab */}
        {tab === 'contatti' && (
          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20, flexWrap: 'wrap', gap: 12 }}>
              <h2>CRM Contatti ({filteredContatti.length})</h2>
              <div style={{ display: 'flex', gap: 8 }}>
                <input placeholder="Cerca..." value={search} onChange={e => setSearch(e.target.value)} style={{ padding: '8px 12px', border: '1px solid #e5e7eb', borderRadius: 8, fontSize: 13 }} />
                <select value={filterStato} onChange={e => setFilterStato(e.target.value)} style={{ padding: '8px 12px', border: '1px solid #e5e7eb', borderRadius: 8, fontSize: 13 }}>
                  <option value="">Tutti gli stati</option>
                  <option value="nuovo">Nuovo</option>
                  <option value="contattato">Contattato</option>
                  <option value="qualificato">Qualificato</option>
                  <option value="chiuso">Chiuso</option>
                </select>
                <button onClick={exportCSV} className="btn btn-sm btn-outline">Export CSV</button>
              </div>
            </div>

            <div className="table-container">
              <table>
                <thead>
                  <tr><th>Nome</th><th>Email</th><th>Telefono</th><th>Azienda</th><th>Tipo</th><th>Stato</th><th>Data</th><th>Azioni</th></tr>
                </thead>
                <tbody>
                  {filteredContatti.map(c => (
                    <tr key={c.id}>
                      <td>{c.nome} {c.cognome}</td>
                      <td>{c.email}</td>
                      <td>{c.telefono}</td>
                      <td>{c.azienda}</td>
                      <td>{c.tipo}</td>
                      <td>
                        <select value={c.stato} onChange={e => updateContatto(c.id, e.target.value)} style={{ padding: '4px 8px', border: '1px solid #e5e7eb', borderRadius: 4, fontSize: 12 }}>
                          <option value="nuovo">Nuovo</option>
                          <option value="contattato">Contattato</option>
                          <option value="qualificato">Qualificato</option>
                          <option value="chiuso">Chiuso</option>
                        </select>
                      </td>
                      <td>{new Date(c.created_at).toLocaleDateString('it-IT')}</td>
                      <td>
                        <button onClick={() => { setSelectedContact(c); setNoteEdit(c.note || ''); loadStorico(c.id); }} className="btn btn-sm btn-outline">Dettagli</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Contact Detail Modal */}
            {selectedContact && (
              <div className="popup-overlay" onClick={() => setSelectedContact(null)}>
                <div className="popup-content" onClick={e => e.stopPropagation()} style={{ maxWidth: 600, textAlign: 'left' }}>
                  <button className="popup-close" onClick={() => setSelectedContact(null)}>&times;</button>
                  <h3 style={{ marginBottom: 16 }}>Dettaglio Contatto</h3>
                  <div className="grid-2" style={{ gap: 8, marginBottom: 16 }}>
                    <div><strong>Nome:</strong> {selectedContact.nome} {selectedContact.cognome}</div>
                    <div><strong>Email:</strong> {selectedContact.email}</div>
                    <div><strong>Telefono:</strong> {selectedContact.telefono}</div>
                    <div><strong>Azienda:</strong> {selectedContact.azienda}</div>
                    <div><strong>Tipo:</strong> {selectedContact.tipo}</div>
                    <div><strong>Fonte:</strong> {selectedContact.fonte}</div>
                  </div>
                  {selectedContact.messaggio && (
                    <div style={{ marginBottom: 16, padding: 12, background: '#f9fafb', borderRadius: 8 }}>
                      <strong>Messaggio:</strong><br />{selectedContact.messaggio}
                    </div>
                  )}
                  <div className="form-group">
                    <label>Note</label>
                    <textarea rows={3} value={noteEdit} onChange={e => setNoteEdit(e.target.value)} style={{ width: '100%', padding: 10, border: '1px solid #e5e7eb', borderRadius: 8, fontSize: 13 }} />
                    <button onClick={() => saveNote(selectedContact.id)} className="btn btn-sm btn-primary" style={{ marginTop: 8 }}>Salva Note</button>
                  </div>
                  {storico.length > 0 && (
                    <div style={{ marginTop: 16 }}>
                      <h4 style={{ marginBottom: 8 }}>Storico</h4>
                      {storico.map(s => (
                        <div key={s.id} style={{ fontSize: 12, padding: 8, borderBottom: '1px solid #e5e7eb' }}>
                          <strong>{s.azione}</strong> - {s.utente} - {new Date(s.created_at).toLocaleString('it-IT')}
                          {s.note && <div style={{ color: '#6b7280' }}>{s.note}</div>}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        )}

        {/* Users Tab */}
        {tab === 'users' && (
          <div>
            <h2 style={{ marginBottom: 20 }}>Utenti Registrati ({users.length})</h2>
            <div className="table-container">
              <table>
                <thead>
                  <tr><th>ID</th><th>Email</th><th>Nome</th><th>Telefono</th><th>Azienda</th><th>Regione</th><th>Visura</th><th>Report</th><th>Ruolo</th><th>Data</th></tr>
                </thead>
                <tbody>
                  {users.map(u => (
                    <tr key={u.id}>
                      <td>{u.id}</td>
                      <td>{u.email}</td>
                      <td>{u.nome} {u.cognome}</td>
                      <td>{u.telefono ? <a href={`https://wa.me/${u.telefono.replace(/[^0-9]/g, '')}`} target="_blank" rel="noopener noreferrer" style={{ color: '#16a34a', textDecoration: 'none', fontWeight: 600 }}>{u.telefono} 💬</a> : <span style={{ color: '#9ca3af' }}>—</span>}</td>
                      <td>{u.azienda}</td>
                      <td>{u.regione}</td>
                      <td>{u.visura_path ? <a href={`${u.visura_path}`} target="_blank" rel="noopener noreferrer" style={{ color: '#1a56db', textDecoration: 'none', fontWeight: 600, fontSize: 12, background: '#eff6ff', padding: '4px 10px', borderRadius: 6, display: 'inline-block' }}>📄 Scarica</a> : <span style={{ color: '#dc2626' }}>No</span>}</td>
                      <td>{u.report_sbloccato ? <span className="status status-qualificato">Sbloccato</span> : u.report_path ? <span className="status status-contattato">Generato</span> : <span className="status status-chiuso">No</span>}</td>
                      <td>{u.ruolo}</td>
                      <td>{new Date(u.created_at).toLocaleDateString('it-IT')}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
